import React from 'react';
import BuyAme from '@catalogo/ui-americanas-mobile-buy-ame';
import WeddingList from '@catalogo/ui-americanas-mobile-wedding-list';

export const SecondaryButton = ({ enableAme, isWeddingList, currentSku, customer, history }) => {
  if (isWeddingList) {
    return <WeddingList currentSku={currentSku} />;
  }

  return enableAme && <BuyAme fullWidth={false} customer={customer} history={history} />;
};
